import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { AccountService } from 'src/app/services/account.service';
import { BridgeService } from 'src/app/services/bridge.service';
import { isAddress } from 'viem'
import { BscContractService } from 'src/app/services/bsc-contract.service';
import { CommonService } from 'src/app/services/common.service';

import { V2ContractService } from 'src/app/services/v2-contract.service';
import { environment } from 'src/environments/environment';
import { ToastrService } from 'ngx-toastr';

const abi = require('src/contracts/abi-dev/bscBridge.json');
const ethabi = require('src/contracts/abi-dev/ethBridge.json');
import { switchNetwork, waitForTransaction, writeContract } from '@wagmi/core'
 
import {

  bscTestnet,
  goerli,
} from "@wagmi/core/chains";


const chains = [bscTestnet, goerli];
const projectId = environment.projectId;
@Component({
  selector: 'app-bridge',
  templateUrl: './bridge.component.html',
  styleUrls: ['./bridge.component.css']
})
export class BridgeComponent implements OnInit {

  account: any = {};
  successMessage: any = '';
  migrationAmount = 0;
  transactionHash: any = "";
  migrationTransactions: any = [];
  isLoading: boolean = false;
  isEthereumNetwork: boolean = false;
  isBinanceNetwork: boolean = false;
  v2Balance: any = 0;
  bridgeForm: any
  connector: any;
  ETHChainId = environment.SUPPORTED_NETWORK[0];
  BNBChainId = environment.SUPPORTED_NETWORK[1];
  isSupportNetwork = false;
  @ViewChild('switchNetworkModalClose') switchNetworkModalClose:ElementRef

  constructor(
    private bridgeService: BridgeService,
    private accountService: AccountService,
    private formBuilder: FormBuilder,
    private commonService: CommonService,
    private v2ContractService: V2ContractService,
    private toastr: ToastrService,
    private bscContractService: BscContractService
  ) {
    this.bridgeForm = this.formBuilder.group({
      bridgeAmount: [0, [Validators.required, Validators.pattern(/^[1-9]\d*$/)]],
      bridgeAddress: ['', [Validators.required, Validators.maxLength(42)]],
      bridgeFrom: ['eth', [Validators.required]],
      bridgeTo: ['bsc', [Validators.required]]
    });
  }

  ngOnInit(): void {
   

    // Listening to account change
    this.accountService.accountObserve.subscribe((data) => {
      this.switchNetworkModalClose.nativeElement.click();
      // this.initProvider();
      this.account = data;
      if(environment.SUPPORTED_NETWORK.includes(this.account.chainId)){
        this.isSupportNetwork = true;
      }
      else{
        this.isSupportNetwork = false;
      }
      
      if (environment.SUPPORTED_NETWORK[0] == +data.chainId) {
        this.bridgeForm.setValue({ bridgeFrom: 'eth', bridgeTo: 'bsc', bridgeAmount: 0, bridgeAddress: this.account.address });
        this.isEthereumNetwork = true;
        this.isBinanceNetwork = false;
        // this.getBalance();
        document.getElementById('bridge-select1-eth').style.display = 'block';
        document.getElementById("bridge-select1-bsc").style.display = 'none';
        document.getElementById("bridge-select2-bsc").style.display = 'block';
        document.getElementById("bridge-select2-eth").style.display = 'none';
      } else {
        this.isBinanceNetwork = true;
        this.isEthereumNetwork = false;
        this.bridgeForm.setValue({ bridgeFrom: 'bsc', bridgeTo: 'eth', bridgeAmount: 0, bridgeAddress: this.account.address });
        // this.getBalance();
        document.getElementById('bridge-select1-eth').style.display = 'none';
        document.getElementById("bridge-select1-bsc").style.display = 'block';
        document.getElementById("bridge-select2-bsc").style.display = 'none';
        document.getElementById("bridge-select2-eth").style.display = 'block';
      }
    });
  }

  async getBalance() {
    if (this.isEthereumNetwork == true) {
      let decimals = await this.v2ContractService.getDecimals();
      let balance = await this.v2ContractService.getBalance(this.account.address);
      this.v2Balance = Number(balance) / 10 ** decimals;
      
    } else {
      let decimals = await this.bscContractService.getDecimals();
      let balance = await this.bscContractService.getBalance(this.account.address);

      this.v2Balance = Number(balance) / 10 ** decimals;
    }
    (<HTMLInputElement>document.getElementById("bridgeAmount")).value = this.v2Balance;
  }

  async setMax() {
    this.getBalance();
    this.bridgeForm.setValue({ bridgeFrom: this.bridgeForm.get("bridgeFrom").value, bridgeTo: this.bridgeForm.get("bridgeTo").value, bridgeAmount: this.v2Balance, bridgeAddress: this.bridgeForm.get("bridgeAddress").value });
  }

  async getEthSignature() {
    let decimals: any = await this.v2ContractService.getDecimals();
    let operation: any = await this.getOperation(this.bridgeForm.get("bridgeFrom").value, this.bridgeForm.get("bridgeTo").value);
    let formValue = this.bridgeForm.get("bridgeAmount").value;
    let to_address = this.bridgeForm.get("bridgeAddress").value;
    this.migrationAmount = Number(formValue);
    let amount = await this.commonService.toFixed(formValue * Math.pow(10, parseInt(decimals || 18)));
    let query = {
      from_address: this.account.address,
      to_address,
      operation,
      amount,
    }

    try {
      let response = await this.bridgeService.getSignature(query).toPromise();
      return ({ signature: response['data'], nonce: response['nonce'], operation, amount, to: to_address });
    } catch (error) {
      this.toastr.error(error)
      this.isLoading = false;
    }
  }

  async getBscSignature() {
    let decimals = await this.bscContractService.getDecimals();
    let operation = await this.getOperation(this.bridgeForm.get("bridgeFrom").value, this.bridgeForm.get("bridgeTo").value);
    let formValue = this.bridgeForm.get("bridgeAmount").value;
    let to_address = this.bridgeForm.get("bridgeAddress").value;

    this.migrationAmount = Number(formValue);
    let amount = await this.commonService.toFixed(formValue * Math.pow(10, parseInt(decimals || 18)));
    let query = {
      from_address: this.account.address,
      to_address,
      operation,
      amount,
    }

    try {
      let response = await this.bridgeService.getSignature(query).toPromise();
      return ({ signature: response['data'], nonce: response['nonce'], operation, amount, to: to_address });
    } catch (error) {
      this.isLoading = false;
      this.toastr.error(error)
    }
  }

  getOperation(bridgeFrom, bridgeTo) {
    let operation;
    if (bridgeFrom === bridgeTo) {

    } else if (bridgeFrom === 'eth' && bridgeTo === 'bsc') {
      operation = 'ETH-BURN';
    } else if (bridgeFrom === 'bsc' && bridgeTo === 'eth') {
      operation = 'BSC-BURN';
    }
    return operation;
  }

  async swap() {
    this.isLoading = true;
    let bridgeAmountValue = this.bridgeForm.get("bridgeAmount").value;
    let bridgeAddress: any = this.bridgeForm.get("bridgeAddress").value;
    if (bridgeAmountValue <= 0 || bridgeAmountValue == null) {
      this.toastr.error('Please Enter Valid Amount');
      this.isLoading = false;
      return false;
    }

    if (bridgeAddress == "" || !isAddress(bridgeAddress)) {
      this.toastr.error('Please Enter Valid Address');
      this.isLoading = false;
      return false;
    }
    try {
      const { amount, nonce, signature, operation, to } = (environment.SUPPORTED_NETWORK[0] == this.account.chainId) ? await this.getEthSignature() : await this.getBscSignature();
      let query = {
        to, amount, nonce, signature
      }

      if (operation === "ETH-BURN") this.burnEthTokens(query)
      else if (operation === "BSC-BURN") this.burnBscTokens(query)
    } catch (error) {
      this.isLoading = false;
      this.toastr.error(error)
    }
  }

  async burnEthTokens(query) {
    try {
      const { hash } = await writeContract({
        abi: ethabi,
        address: environment.ETH_BRIDGE_ADDRESS,
        functionName: 'burn',
        args: [query.to, query.amount, query.nonce, query.signature]
      })
      if (hash) {
        const _waitForTransaction = await waitForTransaction({
          confirmations: 1,
          hash: hash,
        }).then((res: any) => {
          this.isLoading = false;
          this.toastr.success('Process Completed successfully');
          setTimeout(() => {
            this.toastr.info('Please change the network to redeem tokens');
          }, 1000);
          const network = this.bridgeForm.get("bridgeFrom").value;
         
            this.successMessage = "Swap " + this.migrationAmount + " BX Token ETH for " + this.migrationAmount + " BX Token BSC"
          
          this.transactionHash = hash
          this.migrationTransactions.push({ network: network, transactionHash: this.transactionHash, successMessage: this.successMessage });
        })

      }
    } catch (error: any) {
      this.isLoading = false;
      this.isLoading = false;
      if (error.code == 4001) {
        this.toastr.error('User rejected');
      } else {
        error = await JSON.stringify(error, null, 2);
        error = await JSON.parse(error);
        this.toastr.error(error.shortMessage);
      }
    }
  }

  async burnBscTokens(query) {
    try {
      const { hash } = await writeContract({
        abi: abi,
        address: environment.BSC_BRIDGE_ADDRESS,
        functionName: 'burn',
        args: [query.to, query.amount, query.nonce, query.signature]
      })
      if (hash) {
        const _waitForTransaction = await waitForTransaction({
          confirmations: 1,
          hash: hash,
        }).then((res: any) => {
          this.isLoading = false;
          this.toastr.success('Process Completed successfully');
          setTimeout(() => {
            this.toastr.info('Please change the network to redeem tokens');
          }, 1000);
          const network = this.bridgeForm.get("bridgeFrom").value;

          this.successMessage = "Swap " + this.migrationAmount + " BX Token BSC for " + this.migrationAmount + " BX Token ETH"

          this.transactionHash = hash
          this.migrationTransactions.push({ network: network, transactionHash: this.transactionHash, successMessage: this.successMessage });
        })
      }
    } catch (error: any) {
      this.isLoading = false;
      if (error.code == 4001) {
        this.toastr.error('User rejected');
      } else {
        error = await JSON.stringify(error, null, 2);
        error = await JSON.parse(error);
        this.toastr.error(error.shortMessage);
      }
    }

  }

   /**
   * Connects wallet
   */
   public connectWallet() {
    const data = {
      status: true,
    };
    this.accountService.openWallet(data);
  }

  /**
   * Changes network
   * @param {number} chainId 
   */
  changeNetwork(chainId:number){
    switchNetwork({
      chainId: chainId,
    })
  }
  
}
